var DateNoTz = require("./DateNoTz");
var TimePeriod = require("./TimePeriod");

class DateChecker {
    // ------------ New V2 Methods using DateNoTz
    getTimePeriodFromWeekSettings(serverDate, bookingLeadWeekCount, cutOffDay, cutOffTime) {
        var startDay = new DateNoTz(serverDate);
        var endDay = new DateNoTz(serverDate);

        // If Day now is == to Cutoff Day, check time
        if (startDay.dayNumber == cutOffDay) {
            let cutOffDate = new DateNoTz(serverDate);
            cutOffDate.setTime(cutOffTime);

            if (startDay.convertToSeconds() > cutOffDate.convertToSeconds()) {
                endDay.shiftToNextInstanceOfDay(cutOffDay, true)
            }
        }
        else{
            endDay.shiftToNextInstanceOfDay(cutOffDay, true)
        }

        // Shift to the next cutoff day x weeks away
        bookingLeadWeekCount--
        bookingLeadCount =  bookingLeadWeekCount >= 0 ? bookingLeadWeekCount : 0
        var daysToAdvance = bookingLeadWeekCount * 7;
        endDay.shift(daysToAdvance);
        endDay.shiftToNextInstanceOfDay(0, true); // Find the next Sunday
        endDay.setTime("23:59")
        startDay.shift(-1)
        startDay.setTime("00:00")
        var blockOffPeriod = new TimePeriod(startDay.asJsDate(), endDay.asJsDate());
        return blockOffPeriod;
    }

    isDateBeforeAnotherDate(beforeDateString, afterDateString) {
        var beforeDate = new DateNoTz(beforeDateString)
        var afterDate = new DateNoTz(afterDateString)
        
        beforeDate.setTime("00:00:00")
        afterDate.setTime("00:00:00")

        return beforeDate.convertToSeconds() < afterDate.convertToSeconds()
    }
    isDateTimeBeforeTime(dateTimeString, timeString) { // Checks if a dateTime is past a certain time of the dy
        var beforeDate = new DateNoTz(dateTimeString)
        var afterDate = new DateNoTz(dateTimeString)

        // Set after time
        afterDate.setTime(timeString)

        return beforeDate.convertToSeconds() < afterDate.convertToSeconds()
    }


    // ------------ V1 Methods that don't use DateNoTz
    mergePeriods(firstPeriod, secondPeriod) {
        if (
            !firstPeriod ||
            !firstPeriod.endDate ||
            !secondPeriod ||
            !secondPeriod.startDate
        ) {
            return null;
        }
        var returnObj = {
            enable: {
                start: firstPeriod.startDate,
                end: secondPeriod.endDate
            }
        };
        if (firstPeriod.endDate.getTime() < secondPeriod.startDate.getTime()) {
            returnObj.disable = {
                start: firstPeriod.endDate,
                end: secondPeriod.startDate
            };
        }
        return returnObj;
    }

    getAvailableEntitledDates(
        availableDatesOfAddress,
        periodType,
        entitlementSummary
    ) {
        var availableEntitledDates = [];

        availableDatesOfAddress.forEach(availableDateOfAddress => {
            var date = new Date(availableDateOfAddress.date);
            var availableBookings =
                typeof availableDateOfAddress.availableBookings === "string"
                    ? parseInt(availableDateOfAddress.availableBookings, 10)
                    : availableDateOfAddress.availableBookings;
            if (
                (!entitlementSummary || entitlementSummary.containsDate(date)) &&
                availableBookings > 0
            ) {
                if (periodType === "weekly" || periodType === "predefined_week") {
                    var dates = this.getWeekOfDate(date).splice(1, 5); //Remove Sunday and Saturday
                    availableEntitledDates = [...availableEntitledDates, ...dates];
                } else {
                    availableEntitledDates.push(date);
                }
            }
        });
        availableEntitledDates = this.removeDuplicateDates(availableEntitledDates);
        return availableEntitledDates;
    }

    shiftDayDate(baseDate, targetDay, isForward) {
        // Base Date: JS Date that is
        // Target Day: integer of day, Sun = 0 and Sat = 6. Defaults to Sunday
        // isForward: Looks for a date after base date if true, else looks for date before base date
        // Returns next Date of the targetDay
        if (!baseDate) {
            baseDate = new Date();
        }
        if (!targetDay) {
            targetDay = 0;
        }

        var foundDate = new Date(baseDate);
        var step = isForward ? 1 : -1;
        for (let i = 0; i < 7; i++) {
            // Cap it at 7 to prevent infinite loops
            foundDate.setDate(foundDate.getDate() + step);
            if (foundDate.getDay() == targetDay) {
                foundDate = foundDate;
                break;
            }
        }
        return foundDate;
    }

    getWeekOfDate(inDate) {
        // Starts with Sunday
        var date = new Date(inDate) // Prevents mutation of arguments
        var week = [];
        var first = date.getDate() - date.getDay();
        date.setDate(first);
        for (var i = 0; i < 7; i++) {
            week.push(new Date(+date));
            date.setDate(date.getDate() + 1);
        }
        return week;
    }

    removeDuplicateDates(dateArray) {
        return dateArray
            .map(function (date) {
                return date.getTime();
            })
            .filter(function (date, i, array) {
                return array.indexOf(date) === i;
            })
            .map(function (time) {
                return new Date(time);
            });
    }

    isTimeBeforeOtherTime(beforeTime, afterTime) {
        if (!beforeTime || !afterTime) {
            return;
        }
        // Used to compare Times without dates (because vanilla javascript has no support for that)
        //Returns True if beforeTime is truly before afterTime
        // beforeTime and afterTime can come in string form
        // We're assuming both times fall on the same day

        typeof beforeTime === "string"
            ? (beforeTime = stringTimeToTimeObj(beforeTime))
            : null;
        typeof afterTime === "string"
            ? (afterTime = stringTimeToTimeObj(afterTime))
            : null;

        // Compare Hours, Minutes, and Seconds
        if (beforeTime.hours < afterTime.hours) {
            return true;
        } else if (
            beforeTime.hours === afterTime.hours &&
            beforeTime.minutes < afterTime.minutes
        ) {
            return true;
        } else if (
            beforeTime.hours === afterTime.hours &&
            beforeTime.minutes === afterTime.minutes &&
            beforeTime.seconds < afterTime.seconds
        ) {
            return true;
        } else {
            return false;
        }
    }
    
    arePeriodsTheSame(periodOne, periodTwo) {
        if (
            (!periodOne && periodTwo) ||
            (periodOne && !periodTwo) ||
            (isNull(periodOne) && !isNull(periodTwo)) ||
            (!isNull(periodOne) && isNull(periodTwo))
        ) {
            return false;
        } else if (
            (!periodOne && !periodTwo) ||
            (isNull(periodOne) && isNull(periodTwo))
        ) {
            return true;
        } else if (typeof periodOne == "object" && typeof periodTwo == "object") {
            // ALso checks if it's an object
            // Check if Start and End Exists
            if (
                isNull(periodOne.start) &&
                isNull(periodTwo.end) &&
                isNull(periodTwo.start) &&
                isNull(periodTwo.end)
            ) {
                return periodOne.getTime() == periodTwo.getTime();
            } else {
                return (
                    periodOne.start.getTime() == periodTwo.start.getTime() &&
                    periodOne.end.getTime() == periodTwo.end.getTime()
                );
            }
        } else {
            return false;
        }
    }
}

function stringTimeToTimeObj(stringTime) {
    // This function assumes the time is a delimitted string
    var knownDelimiters = [":", "-", "/"]; // Using a constant set as this is faster than programmatically checking

    var foundDelimiter = knownDelimiters.find(delimiter => {
        return stringTime.indexOf(delimiter) > -1;
    });

    if (foundDelimiter) {
        var timeArr = stringTime.split(foundDelimiter);
        return {
            hours: Number.isInteger(timeArr[0])
                ? timeArr[0]
                : parseInt(timeArr[0], 10),
            mins: Number.isInteger(timeArr[1])
                ? timeArr[1]
                : parseInt(timeArr[1], 10),
            seconds: Number.isInteger(timeArr[2])
                ? timeArr[2]
                : parseInt(timeArr[2], 10)
        };
    }
}

function isNull(obj) {
    return obj == null;
}
module.exports = DateChecker;
